exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".tippy-popper[x-placement^=bottom] .tippy-tooltip.customTheme-theme .tippy-arrow{border-bottom:8px solid #346f8b}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/EllipsisTextCell.vue"],"names":[],"mappings":"AACA,iFACC,+BAAiC,CACjC","file":"EllipsisTextCell.vue","sourcesContent":["\n.tippy-popper[x-placement^=bottom] .tippy-tooltip.customTheme-theme .tippy-arrow {\n\tborder-bottom: 8px solid #346F8B;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ca4c0bba","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Systems/EllipsisTextCell.vue
// module id = 2169
// module chunks = 13